<template>
    <section style="margin:18px;">
        <v-data-table :headers="headers" 
                      :items="Transactions" 
                      hide-actions
                      disable-initial-sort
                      class="elevation-1" 
                      style="margin-bottom: 10px;"
                      :loading='loading' 
                      loading-text="Loading... Please wait">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text"> {{ header.text }}</th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td class="text-xs-center">{{ props.item.Name }}</td>
                        <td class="text-xs-center">{{ props.item.Email }}</td>
                        <td class="text-xs-center">{{ props.item.Phone_Number }}</td>
                        <td class="text-xs-center">{{ props.item.Query ? props.item.Query : "" }}</td>
                        <td class="text-xs-center">{{ new Date(props.item.Created_On).toLocaleDateString() }}</td>
                    </tr>
                </template>
            </v-data-table>
            <pagination v-model="pages" :records="records" :per-page="10" @paginate="GetNextSetOfData"></pagination>
    </section>
</template>
<script>
export default {

    data(){

        return {

            headers                     : [ { text: 'Name' , value : 'Name'},
                                            { text: 'Email' , value : 'Email'},
                                            { text: 'Phone Number',value: 'Phone_Number' },
                                            { text: 'Query',value: 'Query' },
                                            { text: 'Created On',value: 'Created_On' } ],
            Transactions                : [],
            pages                       : 1,
            records                     : 0,
            loading                     : false

        }
    },
    methods:{
        GetNextSetOfData(){

            let data = { limit:10, page : this.pages }
            this.$http.post(`${this.$store.getters.GetProductionUrl}/notification/getleads`,data)
                    .then(response =>{
                        
                        this.Transactions = response["data"]["response"]
                        this.records      = response["data"]["Records"]
                        this.loading      = false
                        this.$eventHub.$emit("LOADING",'false')
    
                    })
                    .catch(err =>{
                        this.$eventHub.$emit("LOADING",'false')
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
        }
    },
    mounted(){
        this.GetNextSetOfData()
    }
}
</script>
<style>
.VuePagination ul{
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
 }
.VuePagination li{
    border: 1px solid #887a7a0f !important;
 }
 .pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
}
.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    text-decoration: none;
}
.VuePagination__count {
    font-size: 12px;
    font-weight: bold;
    text-align: right;
    text-transform: capitalize;
}
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
    cursor: pointer;
}
</style>